module.exports = __webpack_public_path__ + "media/118.7bfb092f.mp3";